import React, { useState, useEffect } from 'react'

import CssBaseline from '@mui/material/CssBaseline'
import Box from '@mui/material/Box'
import { MapContainer } from 'react-leaflet'

import 'leaflet-timedimension'

import ColorScale from '../../components/maps/ColorScale'

import useMediaQuery from '@mui/material/useMediaQuery'
import { useTheme } from '@mui/material/styles'
import MenuGeoVisualizador from './menuGeoVisualizador'
import { Download, LibraryBooks } from '@mui/icons-material'

import {
    getDefMenuGeoVisualizador,
    prodsDefActivos,
    prodsCategories,
    extraerFechaDesdeArchivo,
} from './defMenuCapasGeoVisualizador'
import SliderFechas from '../../components/controls/SliderFechas'
import axios from 'axios'
import { Escala } from '../../inumet_js_lib/model/escalas/escala'
import { lsdata, lsdataEscalasFijas } from './geoVisualizadorDatosTest'
import { MenuFabIcons } from '../../components/buttons/MenuFabIcons'
import BotonPantallaCompleta from '../../components/buttons/BotonPantallaCompleta'
import TileLayersLeaflet from '../../components/maps/TileLayersLeaflet'
import globalConfig from '../../config/globalConfig'
import { TifsLayers } from '../../components/maps/TifsLayers'

import style from './geoVisualizador.module.css'
import 'leaflet/dist/leaflet.css'
import 'leaflet-timedimension/dist/leaflet.timedimension.control.css'
import paletas from '../../inumet_js_lib/model/colores/paletas'
import moment from 'moment'
import 'moment/locale/es'
import { Paper, Typography } from '@mui/material'

const ESCALA_LS_FILES = ':escala_lsfiles'
const ID_LS_FILES = ':id_lsfiles'
const URL_LS_FILES =
    `${globalConfig.URL_BASE}` +
    'lsdata2.php?id=' +
    ID_LS_FILES +
    '&escala=' +
    ESCALA_LS_FILES

const MAX_TIF_FILES = 100

export default function GeoVisualizador() {
    const theme = useTheme()

    const mobileMode = useMediaQuery(theme.breakpoints.down('md'))
    const [capaIndex, setCapaIndex] = useState(0)
    const [timeIndex, setTimeIndex] = useState(-1)
    const [fechasArchivos, setFechasArchivos] = useState([])
    const [urlsArchivos, setUrlsArchivos] = useState([])
    const [escalasDeArchivos, setEscalasDeArchivos] = useState([])
    const [loadingCapa, setLoadingCapa] = useState(false)
    const [linkDoc, setLinkDoc] = useState(null)

    const [prodName, setProdName] = useState('')
    const getUrlProd = (fileName) => {
        return `${globalConfig.URL_BASE_DATA_REPORTES}${prodsDefActivos[capaIndex].folder}/${fileName}`
    }

    const getUrlLs = (idProd, wildcard=0) => {
        return URL_LS_FILES.replace(ID_LS_FILES, idProd).replace(
            ESCALA_LS_FILES,
            wildcard
        )
    }

    const onClickForward = () => {
        if (timeIndex < fechasArchivos.length - 1) setTimeIndex(timeIndex + 1)
    }

    const onClickBack = () => {
        if (timeIndex > 0) setTimeIndex(timeIndex - 1)
    }

    const onChange = (newValue) => {
        setTimeIndex(newValue)
    }

    useEffect(() => {
        const cambioCategoria = async () => {
            if (capaIndex >= 0) {
                const idProd = prodsDefActivos[capaIndex].id

                let filePath = getUrlLs(
                    prodsDefActivos[capaIndex].id                   
                )
                try {
                    let filesTif = globalConfig.TEST
                        ? lsdata[capaIndex]
                        : await axios.get(filePath)
                    if (globalConfig.TEST)
                        filesTif = filesTif.slice(0, MAX_TIF_FILES)
                    else filesTif = filesTif.data.slice(0, MAX_TIF_FILES)
                    // Invierto el array para que me queden los mas nuevos al final del slider de fechas
                    filesTif = filesTif.reverse()
                    // Construyo el array de fechas con las fechas de cada archivo
                    const urlsTifs = []
                    let fechasCategoria = filesTif.map((fileTif) => {
                        urlsTifs.push(getUrlProd(fileTif))
                        return extraerFechaDesdeArchivo(
                            fileTif,
                            prodsDefActivos[capaIndex].periodicidad
                        )
                    })

                    if (filesTif.length > 0) {
                        let filesEscalasFijas = []
                        let escalasCategoria = []
                        if (prodsDefActivos[capaIndex].escalaEnArchivo) {
                            if (globalConfig.TEST) {
                                filesEscalasFijas = lsdataEscalasFijas[
                                    capaIndex
                                ].slice(0, MAX_TIF_FILES)
                            } else {
                                filePath = getUrlLs(
                                    prodsDefActivos[capaIndex].id,
                                    prodsDefActivos[capaIndex]
                                        .archivoEscalaFijaWildcard
                                )
                            }

                            try {
                                filesEscalasFijas = globalConfig.TEST
                                    ? lsdataEscalasFijas[capaIndex]
                                    : await axios.get(filePath).then((res) => {
                                          return res.data.slice(
                                              0,
                                              MAX_TIF_FILES
                                          )
                                      })
                                let promisesDescargaEscalas = []
                                for (
                                    let i = 0;
                                    i < filesEscalasFijas.length;
                                    i++
                                ) {
                                    const escalaFilePath = getUrlProd(
                                        filesEscalasFijas[i]
                                    )

                                    promisesDescargaEscalas.push(
                                        axios
                                            .get(escalaFilePath)
                                            .then((datosEscala) => {
                                                let escalaNueva = null
                                                let escalaColores = []
                                                if (datosEscala.data) {
                                                    let cantColores =
                                                        datosEscala.data.colores
                                                            .length
                                                    if (idProd === 18) {
                                                        escalaColores =
                                                            paletas.coloresTempsBajas.slice(
                                                                0,
                                                                cantColores
                                                            )
                                                    } else {
                                                        escalaColores =
                                                            paletas.coloresTempAltas.slice(
                                                                -1 * cantColores
                                                            )
                                                    }

                                                    escalaNueva = new Escala(
                                                        datosEscala.data.iniciosIntervalos,
                                                        escalaColores
                                                    )
                                                }
                                                return escalaNueva
                                            })
                                    )
                                }
                                escalasCategoria = await Promise.all(
                                    promisesDescargaEscalas
                                )
                            } catch (err) {
                                console.log(err)
                            }
                        }

                        setEscalasDeArchivos(escalasCategoria)
                        setProdName(
                            prodsCategories[
                                prodsDefActivos[capaIndex].categoryId - 1
                            ].label +
                                ' - ' +
                                prodsDefActivos[capaIndex].label
                        )
                        setTimeIndex(filesTif.length - 1)
                        if (
                            [1, 3].includes(
                                prodsDefActivos[capaIndex].categoryId
                            )
                        ) {
                            fechasCategoria = fechasCategoria.map(
                                (fechaStr) => {
                                    const fecha = moment(fechaStr, 'YYYY-MM-DD')
                                    fecha.locale('es')
                                    const day = fecha.date()
                                    const month = fecha
                                        .format('MMM')
                                        .toUpperCase()
                                    const year = fecha.format('YY')
                                    if (
                                        prodsDefActivos[capaIndex]
                                            .categoryId === 3
                                    ) {
                                        return `${month} ${year}`
                                    }
                                    let decada
                                    if (day === 1) {
                                        decada = '1erDec'
                                    } else if (day === 11) {
                                        decada = '2daDec'
                                    } else if (day === 21) {
                                        decada = '3erDec'
                                    } else {
                                        decada = ''
                                    }

                                    return `${decada} ${month} ${year}`
                                }
                            )
                        }
                        setFechasArchivos(fechasCategoria)
                        setUrlsArchivos(urlsTifs)

                        setLinkDoc(
                            prodsCategories[
                                prodsDefActivos[capaIndex].categoryId - 1
                            ].linkDoc
                        )
                    }
                } catch (error) {
                    console.log(error)
                }
            }
        }
        cambioCategoria()
    }, [capaIndex])

    useEffect(() => {
        if (timeIndex >= 0) {
            setLoadingCapa(true)
        }
    }, [timeIndex])

    const handleRadioChange = (event) => {
        setCapaIndex(menuDef.mapProdsIndex[event.target.value])
        setTimeIndex(-1)
    }

    let escala = prodsDefActivos[capaIndex].escala

    if (
        prodsDefActivos[capaIndex].escalaEnArchivo &&
        escalasDeArchivos.length > timeIndex
    ) {
        escala = escalasDeArchivos[timeIndex]
    }

    const menuDef = getDefMenuGeoVisualizador(handleRadioChange)

    return (
        <React.Fragment>
            <CssBaseline />

            <Box sx={{ height: 'calc(100vh - env(safe-area-inset-bottom))' }}>
                <div className={style.sliderTimelineContainer}>
                    <SliderFechas
                        index={timeIndex}
                        loading={loadingCapa}
                        disableOnLoading={true}
                        fechasMarksCustom={fechasArchivos}
                        textoAvanzaTiempoCustom={mobileMode ? '' : undefined}
                        textoRetrocedeTiempoCustom={mobileMode ? '' : undefined}
                        formato={''}
                        periodicidad={prodsDefActivos[capaIndex].periodicidad}
                        onIFechaChange={(value) => {
                            setTimeIndex(value)
                        }}
                        hintAbajo={true}
                        onChange={onChange}
                        onClickBack={onClickBack}
                        onClickForward={onClickForward}
                    />
                </div>
                <MapContainer
                    className={style.mapContainer}
                    center={globalConfig.CENTRO_URUGUAY}
                    zoom={globalConfig.DEFAULT_ZOOM}
                    zoomControl={false}
                    scrollWheelZoom={true}
                >
                    {/*
                        El boton de capas ocupa top:16 left:16 (56px de alto).
                        Nos alineamos con el y quedamos debajo. No depende del
                        breakpoint: menuGeoVisualizador solo se mueve a la
                        derecha si recibe la prop mcel, que aca no se pasa.
                    */}
                    <Box
                        sx={{
                            position: 'absolute',
                            top: 84,
                            left: 16,
                            zIndex: 1000,
                        }}
                    >
                        <BotonPantallaCompleta texto={false} />
                    </Box>
                    <MenuFabIcons
                        conLogoInumet={false}
                        buttonCaptions={['Descargar Capa ', 'Más información']}
                        buttonIcons={[
                            <Download className="mr-1" key={1} />,
                            <LibraryBooks className="mr-1" key={1} />,
                        ]}
                        buttonsOnClick={[() => {}, () => {}]}
                        buttonLinks={[urlsArchivos[timeIndex], linkDoc]}
                        mobileMode={mobileMode}
                        visible={[true, linkDoc ? true : false]}
                    />
                    <Paper
                        elevation={2}
                        className={style.centerContainer}
                        sx={{
                            backgroundColor: 'rgba(255, 255, 255, 0.9)',
                            padding: '8px 16px',
                            borderRadius: '4px',
                            maxWidth: 'fit-content',
                            margin: '0 auto',
                            zIndex: 999,
                        }}
                    >
                        <Typography
                            variant="subtitle2"
                            sx={{
                                fontWeight: 500,
                                color: 'text.primary',
                            }}
                        >
                            {prodName}
                        </Typography>
                    </Paper>
                    <TileLayersLeaflet />
                    <TifsLayers
                        escalas={escala}
                        activeIndex={timeIndex}
                        escalasContinuas={escalasDeArchivos}
                        opacity={globalConfig.MAP_LAYERS_OPACITY_DEFAULT}
                        urls={urlsArchivos}
                        onReady={() => {
                            setLoadingCapa(false)
                        }}
                    />
                    {escala && (
                        <ColorScale
                            ranges={escala.getAsMinMaxColor()}
                            title={prodsDefActivos[capaIndex].escalaLabel}
                            opacity={globalConfig.MAP_LAYERS_OPACITY_DEFAULT}
                            onDisplayValues={(value) => {
                                if (value === 999) return '+Inf'
                                const esPrecip =
                                    prodsDefActivos[capaIndex].id <= 17
                                if (
                                    esPrecip &&
                                    prodsDefActivos[capaIndex].categoryId !== 3
                                )
                                    return Math.round(value)
                                else return value.toFixed(1)
                            }}
                        />
                    )}
                </MapContainer>

                {capaIndex >= 0 && (
                    <MenuGeoVisualizador
                        menu={menuDef}
                        mobileMode={mobileMode}
                        selectedMenu={prodsDefActivos[capaIndex].name}
                        handleChange={handleRadioChange}
                    />
                )}
            </Box>
        </React.Fragment>
    )
}
